import * as server from "@/utils/http"

export const _page = params => server.get("/task-detailed/page", params);
export const _get = params => server.get("/task-detailed/get", params);
export const _updateStatus = params => server.get("/task-detailed/updateStatus", params);
export const _audit = params => server.post("/task-detailed/audit", params);
export const _batchAudit = params => server.get("/task-detailed/batch-audit", params);
export const _upload = params => server.postfrom("/task-detailed/upload", params);
export const _secondaryPrimary = params => server.postfrom("/task-detailed/secondary-primary", params);
export const _template=params=>server.download('/task-detailed/template',params);
export const _secondaryPrimaryTemplate=params=>server.download('/task-detailed/secondary-primary-template',params);
export const _batchExport=params=>server.download('/task-detailed/batch-export',params);
export const _save = params => server.post("/task-detailed/save", params);
export const _delete = params => server.post("/task-detailed/delete", params);

